import MultiStepMessage from './MultiStepMessage';
import { connect } from 'react-redux';
import { CHATMESSAGE_APPEND_TO_MULTI_STEP_ANSWER } from '../../../store/modules/chat-messages';

// MultiStepMessage as used in the chat UI (in contrast to the DiscoveryMultiStepMessage, the child answers are held on
//  the redux state)
const ChatMultiStepMessage = ({ message, scrollTo, addToBoardCallback, useScrollBuffer, dispatch }) => {
  const addChildAnswer = async event => {
    return dispatch({
      type: CHATMESSAGE_APPEND_TO_MULTI_STEP_ANSWER,
      event,
      answerId: message.answerId
    });
  };

  return (
    <MultiStepMessage
      answerId={message.answerId}
      questionId={message.questionId}
      childAnswers={message?.childAnswers}
      addChildAnswer={addChildAnswer}
      useScrollBuffer={useScrollBuffer}
      scrollTo={scrollTo}
      addToBoardCallback={addToBoardCallback}
    />
  );
};

export default connect()(ChatMultiStepMessage);
